import { NavLink, useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { LayoutDashboard, Users, Layers, UserCircle, CalendarDays, BookOpen, Settings, LogOut, Sun, Moon, CalendarCheck, Wallet, Trophy, ChartNoAxesCombined, Bot, Building2, History } from 'lucide-react'
import { useAuthStore } from '@/store/authStore'
import { useThemeStore } from '@/store/themeStore'
import { authApi } from '@/api/authApi'

const sections = [
  { label: 'Рабочее пространство', items: [
    { path: '/', label: 'Обзор', icon: LayoutDashboard },
    { path: '/athletes', label: 'Спортсмены', icon: Users },
    { path: '/groups', label: 'Группы', icon: Layers },
    { path: '/calendar', label: 'Расписание', icon: CalendarDays },
    { path: '/attendance', label: 'Посещаемость', icon: CalendarCheck },
    { path: '/payments', label: 'Оплаты', icon: Wallet },
    { path: '/events', label: 'Мероприятия', icon: Trophy },
  ] },
  { label: 'Управление и анализ', items: [
    { path: '/analytics', label: 'Аналитика', icon: ChartNoAxesCombined },
    { path: '/activity', label: 'История событий', icon: History },
    { path: '/coaches', label: 'Тренеры', icon: UserCircle },
    { path: '/materials', label: 'Материалы', icon: BookOpen },
    { path: '/ai', label: 'Штаб', icon: Bot },
    { path: '/club', label: 'Клуб и направления', icon: Building2 },
  ] },
]

export function Sidebar() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const logout = useAuthStore(s => s.logout)
  const { isDark, toggleTheme } = useThemeStore()
  const leave = async () => {
    if (!window.dispatchEvent(new Event('procoach:before-scope-change', { cancelable: true }))) return
    const token = localStorage.getItem('refresh_token')
    logout()
    queryClient.clear()
    navigate('/login')
    if (token) await authApi.logout(token)
  }
  return <aside className="pc-sidebar" aria-label="Главная навигация">
    <NavLink to="/" className="flex items-center gap-3 px-3 mb-8" aria-label="ProCoach, обзор">
      <img src="/logo.png" alt="" className="w-9 h-9 rounded-xl" />
      <div><span className="text-lg font-bold tracking-tight">ProCoach</span><div className="pc-eyebrow" style={{ fontSize: 9, letterSpacing: 1.7 }}>Рабочий кабинет</div></div>
    </NavLink>
    <nav className="flex-1 space-y-6">
      {sections.map(section => <div key={section.label}>
        <div className="pc-eyebrow px-3 mb-2" style={{ fontSize: 9, letterSpacing: 1 }}>{section.label}</div>
        <div className="space-y-0.5">{section.items.map(({ path, label, icon: Icon }) =>
          <NavLink key={path} to={path} end={path === '/'} className="pc-nav-link"><Icon size={18} strokeWidth={1.7} /><span>{label}</span></NavLink>)}
        </div>
      </div>)}
    </nav>
    <div className="mt-6 pt-3 border-t" style={{ borderColor: 'var(--border)' }}>
      <NavLink to="/settings" className="pc-nav-link"><Settings size={18} />Настройки</NavLink>
      <button className="pc-nav-link w-full" onClick={toggleTheme}>{isDark ? <Sun size={18} /> : <Moon size={18} />}{isDark ? 'Светлая тема' : 'Тёмная тема'}</button>
      <button className="pc-nav-link w-full" onClick={leave}><LogOut size={18} />Выйти</button>
    </div>
  </aside>
}
